import React, { Component } from "react";
import { Alert } from "antd";
import Spinner from '../../spinner/spinner';
import moment from 'moment-timezone';
import "./barriers.css";

const OtherBarrierCard = ({otherBarrier}) => {
  const barrierUpdatedAt = otherBarrier.updatedAt ? moment.unix(otherBarrier.updatedAt).fromNow() : null;
  return(
    <Alert className="barriers-layout__other-item"
           message={barrierUpdatedAt}
           description={otherBarrier.barrierText}
    />
  );
};

export default class OtherBarriersList extends Component {
  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    }
    const otherBarriers = this.props.data.statistics.churchManager.church.submittedBarriers.otherBarriers;
    return (
      <div>
        <h2 style={{marginBottom: 10}}>Other Barriers</h2>
        { otherBarriers.map((otherBarriers, index) => (
            <OtherBarrierCard key={index} otherBarrier={otherBarriers}/>
          ))
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/barriers/otherBarriersList.js